var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('public-layout-header'),_vm._v(" "),_c('HomeLayoutMain'),_vm._v(" "),_c('public-layout-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }